import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import ExcelReader from 'components/common/FileController/ExcelReader';
import TransDetailModal from '../trans/TransDetailModal';
import { ConfigProvider, Table, Button, Select, DatePicker, Radio, Input, Modal, notification, InputNumber, Tag, Tooltip } from 'antd';
import PaginationComp from  'components/common/PaginationComp';
import { text_companyNm } from 'lib/textChang';
import { CE_TYPE, COMPANY_TYPE } from 'constant';

import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
moment.locale('ko');

@inject('transStore')
@observer
class TransHistoryList extends Component {
  state = {
    modalOpen: false,
    selectData: null,

    // 상태변경 모달
    modalVisible: false,
    changStat: "",
    // 반품사유 입력
    returnReason: '',
  };

  onPageChange = (pageIdx) => {
    this.props.transStore.disOrderDetail(null, pageIdx);
  };

  onSearch = () => {
    this.props.transStore.disOrderDetail(null, 1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const { cGbn, ceType } = this.props;
    const {  
      valCondition,
      onChangValue,

      detailData,
      pageInfoUser,

      disOrderDetail,

      // 반품관련
      reqReturnInfo,
      reOrderList,
      reOrderGoodsList,
      reOrderReturnInfo,
    } = this.props.transStore;
    const { 
      modalOpen, 
      selectData, 
      modalVisible,
      changStat,
      returnReason,
    } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 50, align: 'center' },
      { title: '주문일', dataIndex: 'orDate', width: 130, align: 'center',
        render: (item, record) => { return(
          moment(item).format('YYYY-MM-DD')
        )}
      },
      { title: '주문번호', dataIndex: 'orCartNo', width: '20%', align: 'reft',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 5 }}>{item}</span>
            {record.exceptionYn !== undefined && record.exceptionYn !== null && record.exceptionYn === "Y"
            && <Tag color="blue">기준외주문</Tag>}
          </Fragment>
        )}
      },  
      { title: '주문상태', dataIndex: 'orStat', key: 'orStat', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "1" && <Fragment>승인대기</Fragment>}
            {item === "2" && <Fragment>승인완료</Fragment>}
            {(item === "3") &&
            ((record.rejectReason !== undefined && record.rejectReason !== null && record.rejectReason !== '')
              ? <Tooltip placement="topLeft" title={record.rejectReason}>
                  <span style={{color: 'blue'}}>승인반려</span>
                </Tooltip>
              : <Fragment>승인반려</Fragment>)
            }
            {item === "4" && <Fragment>배송준비</Fragment>}
            {item === "5" && <Fragment>배송중</Fragment>}
            {item === "6" && <Fragment>구매확정</Fragment>}
            {item === "7" && <Fragment>반품신청</Fragment>}
            {item === "8" && <Fragment>반품승인</Fragment>}
            {item === "9" && 
            ((record.rejectReason !== undefined && record.rejectReason !== null && record.rejectReason !== '')
            ? <Tooltip placement="topLeft" title={record.rejectReason}>
                <span style={{color: 'blue'}}>반품반려</span>
              </Tooltip>
            : <Fragment>반품반려</Fragment>)
            }
          </Fragment>
        )}
      },
      { title: '반품신청/재구매', dataIndex: 'returnYn', width: 130, align: 'center',
        render: (item, record) => { 
          return item === "Y" ? (
          <Fragment>
            {(ceType !== process.env.REACT_APP_TYPE_MASTER) &&
              <Button 
                onClick={()=>
                  this.setState({ 
                    modalVisible: true, 
                    selectData: {
                      ...record,
                      orCntOrg: record.orCnt,
                    }, 
                    returnReason: "", 
                    changStat: "7"
              })}>반품신청</Button>
            }
          </Fragment>
          ) : (record.orStat === "8" && record.reOrderYn === 'Y') && (
            <Fragment>
              <Button
                onClick={()=>{
                  reOrderGoodsList(record);
                  this.setState({ 
                    modalVisible: true, 
                    selectData: {
                      ...record, 
                      orCntOrg: Math.abs(record.orCnt),
                      orGdCd: "",
                      orGdPrice: "",
                      orGdSize: "",
                      orCnt: "1",
                      orEtc: "",
                    }, 
                    returnReason: "", 
                    changStat: "1" });
                }}>재구매</Button>
            </Fragment> 
          )
        }
      },
      { title: text_companyNm(), dataIndex: 'orBranchNm', width: 120, align: 'center',
        render: (item) => { 
          if(cGbn === COMPANY_TYPE.BENZ) {
            const sliceIdx = item?.indexOf('(');
            if(sliceIdx > 0 && item?.indexOf(')') > 0){
              return (item.slice(0, sliceIdx))
            }
          }
          return (item)
      }},
      { title: '지사', dataIndex: 'ceSubName', width: 120, align: 'center'},
      { title: '센터', dataIndex: 'orCeNm', width: 150, align: 'center',
        render: (item, record) => { 
          if(cGbn === COMPANY_TYPE.BENZ && record.ceType === CE_TYPE.BRANCH) {
            const sliceIdx = item?.indexOf('(');
            if(sliceIdx > 0 && item?.indexOf(')') > 0){
              return (item.slice(sliceIdx+1, item.length-1))
            }
          }
          return (item)
      }},
      { title: '상품명', dataIndex: 'orGdNm', width: 250, align: 'center' },
      { title: '사원명', dataIndex: 'dresserNm', width: 130, align: 'center' },
      { title: '사이즈', dataIndex: 'orGdSize', width: 100, align: 'center',
        render: (item, record, index) => { return(
          item === "기타"
          ? <Tooltip placement="topLeft" title={record.orEtc}>
              <span style={{color: 'blue'}}>{item}</span>
            </Tooltip>
          : item
        )}
      },
      { title: '주문수량', dataIndex: 'orCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'orGdPrice', width: 130 , align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {(item !== undefined && item !== null && item !== '') &&
            (parseInt(item)*parseInt(record.orCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      { title: (cGbn === COMPANY_TYPE.BENZ) ? "인수자" : '담당자성명', 
        dataIndex: 'picNm', width: 150, align: 'left' },
      { title: (cGbn === COMPANY_TYPE.BENZ) ? "연락처" : '담당자연락처', 
        dataIndex: 'picHp', width: 150, align: 'left' },
      { title: '운송장번호', dataIndex: 'orInvoiceNo', width: 100, align: 'center' },  
      { title: '인수자성명', 
        dataIndex: 'mgrUserNm', width: 150, align: 'left' },
      { title: '인수자사번', 
        dataIndex: 'mgrUserId', width: 150, align: 'left' },
      { title: "인수자 연락처", 
        dataIndex: 'mgrUserHp', width: 150, align: 'left' },
      { title: text_companyNm() + '이름', dataIndex: 'officeNm', width: 300, align: 'left' },
    ];
    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">주문기간</span>
              <ConfigProvider locale={koKr}>
                <DatePicker.RangePicker
                  style={{ width: 270, marginRight: '20px' }}
                  format={'YYYY-MM-DD'}
                  allowClear={false}
                  defaultValue={[
                    moment(moment().subtract(1, 'month').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD'), 
                    moment(moment().format('YYYY-MM-DD').toString(), 'YYYY-MM-DD')
                  ]}
                  onChange={(date)=>{
                    onChangValue('strDate', date[0].format('YYYY-MM-DD'));
                    onChangValue('endDate', date[1].format('YYYY-MM-DD'));
                    this.onSearch();
                  }}
                />
              </ConfigProvider>
            </span>
          </div>

          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">주문상태</span>
              <Radio.Group
                size="large"
                onChange={(e)=>{
                  onChangValue('orStat', e.target.value);
                  this.onSearch();
                }}
                value={valCondition.orStat}
              >
                <Radio.Button value="">전체</Radio.Button>    
                <Radio.Button value="1">승인대기</Radio.Button>
                <Radio.Button value="2">승인완료</Radio.Button>
                <Radio.Button value="3">승인반려</Radio.Button>
                <Radio.Button value="4">배송준비</Radio.Button>
                <Radio.Button value="5">배송중</Radio.Button>
                <Radio.Button value="6">구매확정</Radio.Button>
                <Radio.Button value="7">반품신청</Radio.Button>
                <Radio.Button value="8">반품승인</Radio.Button>
                <Radio.Button value="9">반품반려</Radio.Button>
              </Radio.Group>
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        
        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>{
              disOrderDetail(null, 1, value);
            }}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          <h4 style={{ color: 'red' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          </h4>
          
          <div className="button-right">
            <ul>
              <li>
                {/* 엑셀다운로드 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-ORDER-LIST'}
                  schInfo={valCondition}
                />
              </li>
            </ul>
          </div>
        </div>
        
        <Table
          rowKey={(record)=>record.RNUM} 
          columns={(cGbn === COMPANY_TYPE.KNP) 
            ? columns.filter(item=> item?.dataIndex !== 'ceSubName' && item?.dataIndex !== 'orCeNm' && item?.dataIndex !== 'dresserNm' && item?.dataIndex !== 'orInvoiceNo')
            : columns.slice(0, columns.length-4)
          }
          dataSource={detailData}
          pagination={false}
          scroll={{ x: 2000 }}
        />
        <PaginationComp 
          pageInfo={pageInfoUser}
          onChange={this.onPageChange}
        />
        
        {/* 상세보기 모달 */}
        <TransDetailModal
          crudYn={false}
          modalOpen={modalOpen}
          modalClose={()=>this.setState({ modalOpen: false })}
          selectData={selectData}
        />

        {/* 상태변경 모달 */}
        <Modal
          width={600}
          title={ (changStat === "7") ? "반품하기"
                : (changStat === "1") ? "재구매"
                : ""
          }
          cancelText={"취소"}
          okText={"확인"}
          closable={false}
          visible={modalVisible}
          onCancel={()=>this.setState({ modalVisible: false })}
          onOk={()=>{
            if (selectData === null) {
              notification.warning({placement: 'bottomLeft', message: `선택정보가 없습니다.`, duration: 2});
              this.setState({ modalVisible: false });
              return;
            }
            if (changStat === "7") {
              if (returnReason === "") {
                notification.warning({placement: 'bottomLeft', message: `사유를 입력해주세요.`, duration: 2});
                return;
              }
              if (parseInt(selectData.orCnt) > parseInt(selectData.orCntOrg)) {
                notification.warning({placement: 'bottomLeft', message: `주문된 수량 이하로 주문해주세요.`, duration: 2});
                return;
              }
              reqReturnInfo({...selectData, returnReason: returnReason, orStat: changStat});
            } else if (changStat === "1") {
              if (selectData.orGdCd === "") {
                notification.warning({placement: 'bottomLeft', message: `상품을 선택해주세요.`, duration: 2});
                return;
              }
              if (selectData.orGdSize === "") {
                notification.warning({placement: 'bottomLeft', message: `사이즈를 선택해주세요.`, duration: 2});
                return;
              }
              if (parseInt(selectData.orCnt) > parseInt(selectData.orCntOrg)) {
                notification.warning({placement: 'bottomLeft', message: `반품된 수량 이하로 주문해주세요.`, duration: 2});
                return;
              }
              if (selectData.orGdSize === "") {
                notification.warning({placement: 'bottomLeft', message: `사이즈를 선택해주세요.`, duration: 2});
                return;
              }
              if (selectData.orGdSize === '기타' && selectData.orEtc === '') {
                notification.warning({placement: 'bottomLeft', message: process.env.REACT_APP_ETCSIZE, duration: 2});
                return;
              }
              reOrderReturnInfo({...selectData, orStat: changStat});
            }
            
            this.setState({ modalVisible: false });
          }}
        >
          {selectData !== null && changStat === "7" && // "반품하기"
            <Fragment>
              <table className="table_st_wrap">
                <tbody>
                  <tr><th>운송사코드</th><td>{selectData.orUserId}</td></tr>
                  <tr><th>총 건수</th><td>{selectData.orCntOrg}</td></tr>
                  <tr>
                    <th>반품 건수</th>
                    <td>
                      <InputNumber
                        value={selectData.orCnt}
                        min={1}
                        max={selectData.orCntOrg}
                        onChange={(value)=>{
                          this.setState({selectData: {...selectData, orCnt: value }});
                        }}
                        style={{ width: 100 }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>총 주문액</th> 
                    <td>
                      {(selectData.orGdPrice !== undefined && selectData.orGdPrice !== null &&
                        selectData.orGdPrice !== "" && selectData.orCnt !== "")
                      ? (selectData.orGdPrice*selectData.orCnt).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : 0
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>반품사유</th>
                    <td>
                      <Input 
                        placeholder="사유를 입력하세요"
                        value={returnReason}
                        onChange={(e)=>this.setState({returnReason: e.target.value})}
                        style={{ width: '100%'}}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="last_chk_text">
                <b>반품 하시겠습니까?</b>
              </div>
            </Fragment>
          }

          {(selectData !== null && changStat === "1") && // "재구매"
            <Fragment>
              <table className="table_st_wrap">
                <tbody>
                  <tr><th>재주문 가능 수량</th><td>{selectData.orCntOrg}</td></tr>
                  <tr>
                    <th>상품명</th>
                    <td>
                      <Select
                        style={{ width: '50%' }}
                        value={selectData.orGdCd}
                        onChange={(value, option)=>{
                          this.setState({
                            selectData: {
                              ...selectData,
                              orGdCd: value,
                              orGdPrice: option.option.gdPrice,
                              orGdSize: "",
                              orCnt: "1",
                              orEtc: ""
                            }
                          });
                        }}
                      >
                        {reOrderList.length > 0 && reOrderList.map(item=>{
                          return(
                          <Select.Option key={item.gdCd} option={item}>{item.gdNm}</Select.Option>
                          )
                        })}
                      </Select>
                    </td>
                  </tr>
                  <tr>
                    <th>사이즈</th>
                    <td>
                      {(selectData.orGdCd !== undefined && selectData.orGdCd !== null && selectData.orGdCd !== "") 
                      ? (reOrderList.length > 0 && reOrderList.map((item,idx)=>{
                        return (selectData.orGdCd === item.gdCd) && (
                          <Fragment key={idx}>
                            <Select
                              style={{ width: 200 }}
                              value={selectData.orGdSize}
                              onChange={(value, option)=>{
                                this.setState({
                                  selectData: {
                                    ...selectData,
                                    orGdSize: value,
                                    orCnt: "1",
                                    orEtc: ""
                                  }
                                });
                              }}
                            >
                              {item.gdSizeList !== undefined && item.gdSizeList !== null &&
                                item.gdSizeList.map(option=>{
                                return(
                                  <Select.Option
                                    key={option.stSize}
                                    option={option}
                                  >{option.stSize} 재고:{option.stCnt}</Select.Option>
                                )
                              })}
                            </Select>
                          </Fragment>
                        )}))
                      : <Fragment>상품을 선택해주세요</Fragment>
                      }
                    {selectData.orGdSize === "기타" &&
                      <Input
                        placeholder={process.env.REACT_APP_ETCSIZE}
                        value={selectData.orEtc}
                        onChange={(e)=>{
                          this.setState({
                            selectData: {
                              ...selectData,
                              orEtc: e.target.value
                            }
                          });
                        }}
                        style={{ width: 200, marginTop: 8 }}
                      />
                    }
                    </td>
                  </tr>
                  <tr>
                    <th>수량</th>
                    <td>{(selectData.orGdSize !== undefined && selectData.orGdSize !== null && selectData.orGdSize !== "") 
                      ? <InputNumber
                          value={selectData.orCnt}
                          min={1}
                          max={selectData.orCntOrg}
                          onChange={(value)=>{
                            this.setState({
                              selectData: {
                                ...selectData,
                                orCnt: value
                              }
                            });
                          }}
                          style={{ width: 100 }}
                        />
                      : <Fragment>상품 및사이즈를 선택해주세요</Fragment>
                      }
                    </td>
                  </tr>
                  <tr>
                    <th>금액</th>
                    <td>{(selectData.orGdSize !== undefined && selectData.orGdSize !== null && selectData.orGdSize !== ""
                        && selectData.orCnt !== undefined && selectData.orCnt !== null && selectData.orCnt !== ""
                        && selectData.orGdPrice !== undefined && selectData.orGdPrice !== null && selectData.orGdPrice !== "")
                        ? (parseInt(selectData.orGdPrice) > 0 && parseInt(selectData.orGdPrice) > 0) &&
                          ((parseInt(selectData.orGdPrice)*parseInt(selectData.orCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                        : <Fragment>&nbsp;</Fragment>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </Fragment>
          }
        </Modal>
      </Fragment>
    );
  }

}

export default withRouter(TransHistoryList);